module.exports = __webpack_public_path__ + "static/media/secondYellowCard.993c77f4.svg";